import React, {Component} from 'react';
import {
    leavePractice,
    reset,
} from "../redux/actions/register/client-register";
import '../assets/css/dashboard.css';
import {connect} from "react-redux";
import {toast} from "react-toastify";
class LeavePractice extends Component {
    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.msg_leave_practice && this.props.msg_leave_practice !== prevProps.msg_leave_practice) {
            toast(this.props.msg_leave_practice);
            const {
                reset
            } = this.props;
            clearTimeout(this.tmr);
            this.tmr = setTimeout(function () {
                reset();
                this.tmr = null;
                window.location.href = '/settings-practices';
            }, 2000);
            this.Cancel();
        }
    }

    Cancel = () => {
        const {
            handleClose
        } = this.props;
        handleClose();
    };
    deleteToggle = () => {
        const data = {
            auth_id: localStorage.client_id,
            id: localStorage.client_id,
            owner_id: this.props.data,
        };
        const {
            leavePractice
        } = this.props;
        leavePractice(data);
    };
    render() {
        const showHideClassName = this.props.show ? "modal-b display-modal-block" : "modal-b display-modal-none";
        return (
            <div className={showHideClassName}>
                <section className="modal-article">
                    <div className="create-modal-header txt-18 justify-left col-white">Leave Practice</div>
                    <div className="pt-45 pb-30 txt-16 col-blue justify-center">Do you want to leave this practice really?</div>
                    <div className="flex-grid2 modal-grid2-gaps modal-p">
                        <div className="btn-common cancel mouse-cursor justify-center" onClick={this.Cancel}>Cancel</div>
                        <div className="btn-common create btn-delete mouse-cursor justify-center col-white" onClick={this.deleteToggle}>Leave</div>
                    </div>
                </section>
            </div>
        )
    }
}
const mapStateToProps = (state) => {
    return {
        msg_leave_practice: state.registers.msg_leave_practice,
    }
};
export default connect(
    mapStateToProps,
    {
        leavePractice,
        reset,
    }
)(LeavePractice);

